import script from "./DecimalField.vue?vue&type=script&lang=js"
export * from "./DecimalField.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__